module.exports = __webpack_public_path__ + "assets/img/1.35957b02.jpg";